import React, { memo } from 'react';

import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';

import { DateFormat } from '../../types/DateFormat';
import { User as UserType } from '../../types/User';
import { DateText } from '../DateText/DateText';
import { Layout } from '../Layout/Layout';
import { Text } from '../Text/Text';
import { User } from '../User/User';

interface Props {
  /** Activity performed by user */
  activity: string;
  /** JS Date */
  date: Date;
  /** A user object */
  user: UserType;
  /** Date format */
  format?: DateFormat;
}

export const UserActivity = memo(
  ({ activity, date, format = 'iso', user }: Props) => {
    const hasLocalization = useFlag(FlagType.LanguageSelect);

    return (
      <Layout spacing={1} wrap>
        <Text>{activity} at </Text>
        <DateText
          date={date}
          format={
            hasLocalization ? (format === 'iso' ? 'short' : format) : format
          }
        />
        <Text> by </Text>
        <User user={user} mode="name" />
      </Layout>
    );
  },
);
